import React, { FC } from "react";

export interface InitialIconProps {
    style?: React.CSSProperties;
    name: string;
}

export const InitialIcon: FC<InitialIconProps> = props => {
    const defaultStyles = {
        borderRadius: "50%",
        fontSize: "15pt",
        lineHeight: "38px",
        margin: 0,
        textAlign: "center"
    };

    const myStyle = Object.assign({}, defaultStyles, props.style);

    return <p style={myStyle}>{getInitials(props.name)}</p>;
};

function getInitials(name: string): string {
    if (!name) {
        return "NA";
    }

    const split = name.split(" ");
    let returnName = "";
    if (split.length === 1) {
        // Retrieve the first and second letter of the name;
        const useName = split[0];
        returnName = useName.charAt(0);
        if (useName.length > 1) {
            returnName = returnName + useName.charAt(1);
        }
    } else {
        returnName = split[0].charAt(0) + split[split.length - 1].charAt(0);
    }

    return returnName.toUpperCase();
}
